import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { withUnifiedSmartSiteMap, processor, siteMapPropType } from '@bingads-webui-react/with-site-map';
import { withScope, QueryParam } from '@bingads-webui-react/scope-service';
import { withRouter } from '@bingads-webui-react/router';
import { withUserConsumer } from '@bingads-webui-react/user-context';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { createToolbarButton, navigateBySiteMap } from './utilities';

const siteMapId = 'my-website';

const MyWebsiteButtonEmbeded =
  createToolbarButton(['global-menu-my-website-button'], 'ba-Website');

export const MyWebsiteButtonInternal = React.memo(({
  i18n,
  scope,
  siteMap,
  history,
  location,
  userContext,
  permissions,
  ...others
}) => {
  const myWebsiteItem = _.findWhere(siteMap, { id: siteMapId });
  if (_.isEmpty(myWebsiteItem)) {
    return null;
  }

  const onClick = () => {
    if (permissions && permissions.IsSmartPageStandaloneRedirectionEnabled) {
      const {
        values: {
          cid,
          aid,
        },
      } = scope;
      window.open(`/campaign/sp/landing?cid=${cid}&aid=${aid}`);
    } else {
      scope.remove(['campaignId']);
      navigateBySiteMap({
        scope,
        siteMap,
        siteMapId,
        history,
        location,
        userContext,
      });
    }
  };

  const text = i18n.getString(myWebsiteItem.name);
  return (<MyWebsiteButtonEmbeded {...others} onClick={onClick} text={text} />);
});

MyWebsiteButtonInternal.defaultProps = {
  userContext: {},
};

MyWebsiteButtonInternal.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  siteMap: siteMapPropType.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  userContext: PropTypes.shape({
    CurrentAccount: PropTypes.object,
  }),
  permissions: PropTypes.shape({}).isRequired,
};

export const MyWebsiteButton = _.compose(
  withUserConsumer,
  withRouter,
  withScope,
  withPermissions,
  withUnifiedSmartSiteMap
)(
  MyWebsiteButtonInternal,
  [processor.processPermissions, processor.processPath],
  siteMapId
);
